/* global document */
import { Component } from 'react';
import ReactDOM from 'react-dom';

import FeedbackForm from './FeedbackForm';

class Feedback extends Component {
  render() {
    return ReactDOM.createPortal(
      <FeedbackForm />,
      document.getElementById('c7-constellation-feedback')
    );
  }
}

export default Feedback;
